import {TimelineMax, TweenMax} from 'gsap'
import { bus } from '@/consts.js'

export default {
  name: 'BracketMatchup',
  template: '#bracket-matchup-template',
  data () {
    return {
      teamsRevealed: false,
      matchComplete: false,
      bracketLinesTl: new TimelineMax(),
      matchWinTl: new TimelineMax()
    }
  },
  props: ['type', 'victor', 'user-matchup', 'round', 'route', 'bracket'],
  computed: {
    classObj () {
      return {
        'matchup--user': this.userMatchup,
        'matchup--final': this.type === 'final',
        'matchup--large': this.type === 'large',
        'matchup--victor-1': this.victor === 1,
        'matchup--victor-2': this.victor === 2,
        'match-complete': this.matchComplete,
        'matchup--hidden': !this.teamsRevealed
      }
    },
    userTeamLogoPath () {
      return window.clash2018.versionedAssetPath + '/static/svg/' + this.$store.state.teamLogo + '.svg'
    }
  },
  methods: {
    userTeamLineAnimation () {
      let line = this.type === 'final' ? this.$refs.userTeamLineFinal : this.$refs.userTeamLine
      if (line) {
        TweenMax.to(line, 0.5, {scaleX: 1, transformOrigin: 'left'})
      }
    },
    matchWinAnimation () {
      this.matchWinTl.to([ this.$refs.teamtag1, this.$refs.teamtag2 ], 0.3, { y: 9 })
      this.matchWinTl.to([ this.$refs.outcome1, this.$refs.outcome2 ], 0.3, { opacity: 1 })
    },
    roundWinAnimation () {
      TweenMax.to(this.$refs.team1, 0.7, { width: this.$el.clientWidth + 1 })
      TweenMax.to(this.$refs.team1bg, 0.3, {opacity: 1})
      TweenMax.to(this.$refs.vsBox, 0.3, {
        scale: 0,
        opacity: 0,
        onComplete: () => {
          if (this.route) {
            setTimeout(() => {
              this.$router.push(this.route)
            }, 1000)
          }
        }
      })
      TweenMax.to(this.$refs.outcome1, 0.3, { opacity: 1 })
      if (this.userMatchup) {
        this.userTeamLineAnimation()
      }
    },
    bracketLinesAnimation () {
      if (this.userMatchup) {
        if (this.$refs.line1) {
          this.bracketLinesTl.to(this.$refs.line1, 0.2, {scaleX: 1, transformOrigin: 'left'})
        }
        if (this.$refs.line2) {
          this.bracketLinesTl.to(this.$refs.line2, 0.2, {scaleY: 1, transformOrigin: 'center top'})
        }
        if (this.$refs.line3) {
          this.bracketLinesTl.to(this.$refs.line3, 0.2, {scaleX: 1, transformOrigin: 'left'})
        }
      }
    },
    matchWin () {
      this.matchComplete = true
      this.matchWinAnimation()
      if (this.userMatchup) {
        this.userTeamLineAnimation()
      }
    },
    roundWin () {
      this.matchComplete = true
      this.roundWinAnimation()
      if (this.type === 'final') {
        let dayVal = 1
        if (this.bracket === 8) {
          dayVal = 2
        } else if (this.bracket === 16) {
          dayVal = 3
        }
        bus.$emit('roundWin', dayVal)
      }
    }
  },
  created () {
    if (this.round === 1) {
      this.teamsRevealed = true
    }
  },
  mounted () {
    // if in 4-team bracket, show match results immediately
    if (this.bracket === 4) {
      if (this.round === 1) {
        this.matchWin()
      }
      this.matchWinTl.addCallback(() => {
        this.bracketLinesAnimation()
        if (this.round === 2) {
          this.teamsRevealed = true
        }
      }, 0.5)
    }

    // 8-team & 16-team bracket win animations
    if (this.round === 1) {
      bus.$on('bracket8Round1', this.matchWin)
      bus.$on('bracket16Round1', this.matchWin)
    } else if (this.round === 2) {
      bus.$on('bracket8Round2', this.matchWin)
      bus.$on('bracket16Round2', this.matchWin)
    } else if (this.round === 3) {
      bus.$on('bracket16Round3', this.matchWin)
    }

    // 8-team bracket line animations and matchup reveals
    bus.$on('bracket8Move1', () => {
      if (this.round === 1) {
        this.bracketLinesAnimation()
      }
      if (this.round === 2) {
        this.teamsRevealed = true
      }
    })
    bus.$on('bracket8Move2', () => {
      if (this.round === 2) {
        this.bracketLinesAnimation()
      }
      if (this.round === 3) {
        this.teamsRevealed = true
      }
    })

    // 16-team bracket line animations and matchup reveals
    bus.$on('bracket16Move1', () => {
      if (this.round === 1) {
        this.bracketLinesAnimation()
      }
      if (this.round === 2) {
        this.teamsRevealed = true
      }
    })
    bus.$on('bracket16Move2', () => {
      if (this.round === 2) {
        this.bracketLinesAnimation()
      }
      if (this.round === 3) {
        this.teamsRevealed = true
      }
    })
    bus.$on('bracket16Move3', () => {
      if (this.round === 3) {
        this.bracketLinesAnimation()
      }
      if (this.round === 4) {
        this.teamsRevealed = true
      }
    })

    // round win animations
    if (this.type === 'final') {
      bus.$on('bracket4Round2', this.roundWin)
      bus.$on('bracket8Round3', this.roundWin)
      bus.$on('bracket16Round4', this.roundWin)
    }
  },
  beforeDestroy () {
    bus.$off('bracket4Round1')
    bus.$off('bracket4Round2')
    bus.$off('bracket8Round1')
    bus.$off('bracket8Round2')
    bus.$off('bracket8Round3')
    bus.$off('bracket16Round1')
    bus.$off('bracket16Round2')
    bus.$off('bracket16Round3')
    bus.$off('bracket16Round4')
  }
}



// WEBPACK FOOTER //
// ./src/components/triumph/brackets/BracketMatchup.js